import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from "@angular/common/http";
import { AppComponent } from './app.component';
import { AgGridModule } from "@ag-grid-community/angular";


import { faCircle , faWindowClose } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeModule ,FaIconLibrary} from '@fortawesome/angular-fontawesome';
import { MaterialExampleModule } from "../material.module";
import { DoclinkCellRenderer } from "./doclink-cell-renderer/doclink-cell-renderer.component";
import { ContactgridComponent } from './notificationgrid/notificationgrid.component'
import { DatePipe } from '@angular/common';
import { ModalComponent } from './modal/modal.component';

@NgModule({
  declarations: [
    AppComponent,
    DoclinkCellRenderer,
    ContactgridComponent,
    ModalComponent
    
  ],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    HttpClientModule,
    MaterialExampleModule,
    AgGridModule
  ],
  providers: [DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule { 
  constructor(library:FaIconLibrary){
    library.addIcons(faCircle);
    library.addIcons(faWindowClose);
  }
}
